import { Component, OnInit, AfterViewInit, Inject, OnDestroy } from '@angular/core';
import { PortalService } from '../services/portal.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { ISubscription } from "rxjs/Subscription";
import { TopnavService } from '../header/topnav/topnav.service';
import { SharedService } from '../common/shared.service';
import { Title } from '@angular/platform-browser';


/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: May 30th 2018
 * 
 * Description: Component class for Sitemap.
 **/
@Component({
  selector: 'gosg-sitemap',
  templateUrl: './sitemap.component.html',
  styleUrls: ['./sitemap.component.css']
})
export class SitemapComponent implements OnInit, AfterViewInit, OnDestroy {

  lang = this.lang;
  languageId = this.languageId;
  private subscriptionLang: ISubscription;

  constructor(
    private pageTitle: Title,
    private sharedService : SharedService,
    public portalservice: PortalService,
    private translate: TranslateService,
    private topnavservice: TopnavService,
    @Inject(APP_CONFIG) private config: AppConfig) {

      this.subscriptionLang = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
        // this.sharedService.errorHandling(event, (function(){
          const myLang = this.translate.currentLang;
          if (myLang === 'en') {
             this.lang = 'en';
             this.languageId = 1;
          }
          if (myLang === 'ms') {
            this.lang = 'ms';
            this.languageId = 2;
          }

          if(this.topnavservice.flagLang){
            this.portalservice.triggerSiteMap(this.languageId);
            //window.scrollTo(0,0);
          }

          setTimeout(()=>{
            this.translate.get('pageTitle.home').subscribe((title:string) => {
              title = title + this.translate.instant('home.menu.sitemap');
              this.sharedService.setTitle(title);
            }); 
          },500);

      });
  }

  ngOnInit() {

    
  if (!this.languageId) {
      if (localStorage.getItem('langID')) {
        this.languageId = localStorage.getItem('langID');
      } else { 
        this.languageId = 1;
      }
  }

    this.portalservice.triggerSiteMap(this.languageId);
    console.log(this.portalservice.loader)
    window.scrollTo(0,0);
  }

  ngAfterViewInit() {
  
    // Get Title and Sent to GA
    this.translate.get('pageTitle.home').subscribe((title:string) => {
      title = title + this.translate.instant('home.menu.sitemap');
      this.sharedService.setTitleAndGtag(title);
    }); 

  }

  ngOnDestroy() {
    this.subscriptionLang.unsubscribe();
  }

  scrollTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/sitemap/sitemap.component.ts